var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundPlanUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 392,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.102 0h397.73v412s15.388-34.331-69.84-143.511c-85.228-109.18-199.437-74.636-266.337-138.496C-5.245 66.133.102 0 .102 0z",
    fill: "url(#background-plan-upgrade_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-plan-upgrade_svg__paint0_linear",
    x1: 199.457,
    y1: 0,
    x2: 199.457,
    y2: 412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })))));
}
export default SvgBackgroundPlanUpgrade;